import { render, staticRenderFns } from "./training-completion.vue?vue&type=template&id=a2f4ad16&"
import script from "./training-completion.vue?vue&type=script&lang=ts&"
export * from "./training-completion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports